import axios from "axios";
import { del, get, post, patch,  put } from "./academic_cycle_configs_api_helper";
import * as url from "./academic_cycle_configs_url_helper";





// 
export const getAcademicCycleConfigs = () => get(url.GET_ACADEMIC_CYCLE_CONFIGS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewAcademicCycleConfig = academicCycleConfig => post(url.ADD_NEW_ACADEMIC_CYCLE_CONFIG, academicCycleConfig);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateAcademicCycleConfig = academicCycleConfig => patch(`${url.UPDATE_ACADEMIC_CYCLE_CONFIG}/${academicCycleConfig.id}`,  academicCycleConfig);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteAcademicCycleConfig = academicCycleConfig => del(`${url.DELETE_ACADEMIC_CYCLE_CONFIG}/${academicCycleConfig.id}`);







export {
  //getLoggedInUser,
  
  
};
